/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorIllustrationPeopleLight = "rgb(230, 170, 51)";
export const ColorIllustrationPeopleDark = "rgb(184, 138, 45)";
export const ColorIllustrationPeopleDefault = "rgb(230, 170, 51)";
export const ColorIllustrationVehicleLight = "rgb(230, 170, 51)";
export const ColorIllustrationVehicleDark = "rgb(184, 138, 45)";
export const ColorIllustrationVehicleDefault = "rgb(230, 170, 51)";
export const ColorIllustrationNeutral1 = "rgb(255, 255, 255)";
export const ColorIllustrationNeutral2 = "rgb(230, 232, 233)";
export const ColorIllustrationNeutral3 = "rgb(215, 217, 219)";
export const ColorIllustrationNeutral4 = "rgb(184, 188, 191)";
export const ColorIllustrationNeutral5 = "rgb(128, 131, 134)";
export const ColorIllustrationNeutral6 = "rgb(0, 12, 21)";
export const ColorIllustrationPrimaryDefault = "rgb(5, 50, 255)";
export const ColorIllustrationPrimaryLighter = "rgb(141, 164, 239)";
export const ColorIllustrationPrimaryDarker = "rgb(4, 15, 236)";
export const ColorIllustrationAccentDefault = "rgb(230, 170, 51)";
export const ColorIllustrationAccentLighter = "rgb(242, 189, 96)";
export const ColorIllustrationAccentDarker = "rgb(219, 159, 34)";
export const ColorIllustrationSuccessDefault = "rgb(0, 170, 139)";
export const ColorIllustrationCriticalDefault = "rgb(216, 50, 50)";
export const ColorSurfaceDefault = "rgb(255, 255, 255)";
export const ColorSurfaceHovered = "rgb(239, 240, 241)";
export const ColorSurfacePressed = "rgb(230, 232, 233)";
export const ColorSurfaceReduced = "rgb(230, 232, 233)";
export const ColorSurfaceReducedAlternative = "rgb(239, 240, 241)";
export const ColorSurfacePressedAlternative = "rgb(184, 188, 191)";
export const ColorSurfaceSuccess = "rgb(225, 248, 240)";
export const ColorSurfaceCritical = "rgb(255, 235, 233)";
export const ColorSurfaceContrastDefault = "rgb(0, 12, 21)";
export const ColorSurfaceContrastPressed = "rgb(97, 100, 103)";
export const ColorSurfaceSelectedDefault = "rgb(250, 248, 245)";
export const ColorSurfaceSelectedPressed = "rgb(244, 241, 234)";
export const ColorSurfaceDimmedDefault = "rgba(0, 12, 21, 0.1)";
export const ColorSurfaceOverlayDefault = "rgb(255, 255, 255)";
export const ColorSurfaceOverlayHovered = "rgb(239, 240, 241)";
export const ColorSurfaceOverlayPressed = "rgb(230, 232, 233)";
export const ColorContentDefault = "rgb(0, 12, 21)";
export const ColorContentReduced = "rgb(97, 100, 103)";
export const ColorContentDisabled = "rgb(184, 188, 191)";
export const ColorContentOnActionPrimaryDefault = "rgb(255, 255, 255)";
export const ColorContentOnActionPrimaryDisabled = "rgb(224, 233, 255)";
export const ColorContentOnActionPrimaryDisabledAlternative =
  "rgb(255, 255, 255)";
export const ColorContentOnActionSecondaryDefault = "rgb(255, 255, 255)";
export const ColorContentOnActionSecondaryDisabled = "rgb(184, 188, 191)";
export const ColorContentOnAccentDefault = "rgb(255, 255, 255)";
export const ColorContentOnContrastCriticalSuccessDefault =
  "rgb(255, 255, 255)";
export const ColorContentOnContrastCriticalSuccessDefaultAlternative =
  "rgb(255, 255, 255)";
export const ColorContentOnBackgroundFixedDefault = "rgb(255, 255, 255)";
export const ColorActionPrimaryDefault = "rgb(5, 50, 255)";
export const ColorActionPrimaryDefaultDisabled = "rgb(141, 164, 239)";
export const ColorActionPrimaryDisabledAlternative = "rgb(230, 232, 233)";
export const ColorActionPrimaryDefaultPressed = "rgb(4, 15, 236)";
export const ColorActionPrimaryAlternative = "rgb(5, 50, 255)";
export const ColorActionPrimaryAlternativePressed = "rgb(4, 15, 236)";
export const ColorActionPrimaryAlternativePressedReduced = "rgb(193, 208, 255)";
export const ColorActionPrimaryAlternativeDisabled = "rgb(141, 164, 239)";
export const ColorActionPrimaryDefaultHovered = "rgb(4, 15, 236)";
export const ColorActionPrimaryAlternativeHovered = "rgb(4, 15, 236)";
export const ColorActionSecondaryDefault = "rgb(0, 12, 21)";
export const ColorActionSecondaryHovered = "rgb(97, 100, 103)";
export const ColorActionSecondaryPressed = "rgb(128, 131, 134)";
export const ColorActionSecondaryDisabled = "rgb(184, 188, 191)";
export const ColorActionSecondaryPressedReduced = "rgb(239, 240, 241)";
export const ColorActionSecondaryDisabledAlternative = "rgb(239, 240, 241)";
export const ColorAccentDefault = "rgb(5, 50, 255)";
export const ColorAccentAlternative = "rgb(4, 15, 236)";
export const ColorAccentDisabled = "rgb(141, 164, 239)";
export const ColorInputDefault = "rgb(250, 248, 245)";
export const ColorInputDisabled = "rgb(244, 241, 234)";
export const ColorControlsDefault = "rgb(240, 236, 228)";
export const ColorControlsAlternative = "rgb(255, 255, 255)";
export const ColorControlsPressed = "rgb(221, 219, 211)";
export const ColorControlsDisabled = "rgb(250, 248, 245)";
export const ColorCriticalDefault = "rgb(216, 50, 50)";
export const ColorCriticalPressed = "rgb(200, 30, 36)";
export const ColorCriticalDisabled = "rgb(246, 168, 160)";
export const ColorCriticalAlternative = "rgb(255, 235, 233)";
export const ColorCriticalContrast = "rgb(209, 42, 44)";
export const ColorCriticalHovered = "rgb(209, 42, 44)";
export const ColorCriticalOnContrastDefault = "rgb(216, 50, 50)";
export const ColorSuccessDefault = "rgb(0, 170, 139)";
export const ColorSuccessContrast = "rgb(0, 129, 101)";
export const ColorSuccessOnContrastDefault = "rgb(74, 187, 159)";
export const ColorSuccessAlternative = "rgb(225, 248, 240)";
export const ColorWarningDefault = "rgb(236, 191, 102)";
export const ColorWarningPressed = "rgb(242, 212, 153)";
export const ColorWarningAlternative = "rgb(252, 247, 235)";
export const ColorWarningContrast = "rgb(188, 136, 32)";
export const ColorWarningOnContrastDefault = "rgb(234, 183, 82)";
export const ColorBorderOnActionSecondaryDefault = "rgb(184, 188, 191)";
export const ColorBorderOnActionSecondaryDisabled = "rgb(184, 188, 191)";
export const ColorBorderOnInputDefault = "rgb(221, 219, 211)";
export const ColorBorderOnInputActive = "rgb(209, 207, 197)";
export const ColorBorderOnControlDefault = "rgb(221, 219, 211)";
export const ColorBorderOnControlDisabled = "rgb(240, 236, 228)";
export const ColorBorderOnSelectedDefault = "rgb(221, 219, 211)";
export const ColorBorderOnSelectedDisabled = "rgb(240, 236, 228)";
export const ColorBorderOnSuccessDefault = "rgb(74, 187, 159)";
export const ColorBorderOnCriticalDefault = "rgb(237, 142, 132)";
export const ColorAccessoryDefault = "rgb(221, 219, 211)";
export const ColorAccessoryDefaultAlternative = "rgb(240, 236, 228)";
export const ColorAccessoryReduced = "rgb(233, 230, 221)";
export const ColorAccessoryReducedAlternative = "rgb(250, 248, 245)";
export const ColorAccessoryAlternative = "rgb(230, 170, 51)";
export const ColorAccessoryContrast = "rgb(219, 159, 34)";
export const ColorBackgroundDefault = "rgb(250, 248, 245)";
export const ColorBackgroundAlternative = "rgb(255, 255, 255)";
export const ColorBackgroundDimmedDefault = "rgba(0, 12, 21, 0.6)";
export const ColorBackgroundDimmedReduced = "rgba(221, 219, 211, 0.4)";
export const ColorBackgroundDimmedReducedAlternative =
  "rgba(255, 255, 255, 0.85)";
export const ColorBackgroundFixedDefault = "rgb(0, 12, 21)";
export const ColorShimmerDefault =
  "linear-gradient(-90deg, #f0f0f100 0%, #f0f0f1 27.6%, #f0f0f1 65.63%, #f0f0f100 100%)";
export const ColorShadowDefault = "rgba(140, 146, 150, 0.2)";
export const ColorShadowReduced = "rgba(221, 219, 211, 0.5)";
